import { searchTabOptions } from '@/components/universal-search/contant';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { OverviewCollapseWrapper } from '@/components/shared/contacts';
import {
  useGetProjectsConfig,
  useGetFlowsConfig,
  useGetJobsConfig,
} from '@/components/contacts/CanidateOverviewHelpers';
import {
  Badge,
  Box,
  Flex,
  Tab,
  TabList,
  Tabs,
  TabPanels,
} from '@chakra-ui/react';
import { useState } from 'react';
import { TabPanel } from 'react-headless-tabs';
import { KText } from 'ui-library/components';
import { EmptyResults } from '../../empty-results';
import { NoApplications } from '@/assets/icons/ats/empty';

const TabContent = ({ type, list, columnsConfig, count }) => {
  return count && count > 0 ? (
    <Flex flexDir="column" overflowY="auto" maxH="250px">
      <OverviewCollapseWrapper
        list={list}
        type={type}
        columnsConfig={columnsConfig}
        isCollapsed={false}
      />
    </Flex>
  ) : (
    <Flex maxH="250px" alignItems="center" pt="30px" justifyContent="center">
      <EmptyResults
        icon={NoApplications}
        text={`The candidate isn’t a part of any ${type}.`}
        iconProps={{ h: '140px', w: '140px', mb: '0px' }}
        textProps={{ size: 'md-semi-bold' }}
      />
    </Flex>
  );
};

export const CandidateRecords = ({ candidate }) => {
  const { projects, outreaches, ats_applications } = candidate;
  const projectsColumnsConfig = useGetProjectsConfig({ canEditStatus: false });
  const flowsColumnsConfig = useGetFlowsConfig({ canEditStage: false });
  const jobsColumnsConfig = useGetJobsConfig();
  const [tabIndex, setTabIndex] = useState(0);
  const { track } = useMixpanel();

  const TabOptions = [
    {
      id: 0,
      label: 'Jobs',
      data: ats_applications,
      columnsConfig: jobsColumnsConfig,
      count: ats_applications?.length || 0,
      type: 'jobs',
    },
    {
      id: 1,
      label: 'Projects',
      data: projects,
      columnsConfig: projectsColumnsConfig,
      count: projects?.length,
      type: 'project',
    },
    {
      id: 2,
      label: 'Flows',
      data: outreaches,
      columnsConfig: flowsColumnsConfig,
      count: outreaches?.length,
      type: 'flow',
    },
  ];

  const handleTabChange = (index) => {
    setTabIndex(index);
    track({
      event: 'global-search-tab-change',
      prop: {
        'selected-tab': searchTabOptions.find((tab) => tab.id === index)?.label,
      },
    });
  };

  return (
    <Tabs onChange={handleTabChange} isLazy>
      <Flex alignItems="center">
        <TabList
          borderColor="border-color"
          borderBottom="1px solid"
          width={'100%'}
        >
          {TabOptions?.map((option) => (
            <Tab
              px="12px"
              pb="12px"
              key={option.id}
              fontSize="14px"
              _focus={{
                outline: 'none',
                borderColor: 'transparent',
              }}
              borderBottom="border-color"
              _selected={{
                borderBottom: '2px solid',
                borderBottomColor: '#605AFB',
                color: '#605AFB',
              }}
              _active={{
                bg: 'transparent',
              }}
              gap="8px"
            >
              <Badge
                p="3px"
                background={
                  tabIndex === option.id ? 'primary-100' : 'secondary-50'
                }
                color={tabIndex === option.id ? 'primary-600' : 'secondary-700'}
                minW="21px"
                minH="18px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {option?.count}
              </Badge>
              <KText
                size="sm-medium"
                color={tabIndex === option.id ? 'primary-600' : 'secondary-700'}
                as="span"
              >
                {option?.label}
              </KText>
            </Tab>
          ))}
        </TabList>
      </Flex>
      <Box position="relative" height="250px">
        <TabPanels>
          {TabOptions.map((option) => (
            <TabPanel key={option.id} hidden={null}>
              {tabIndex === option.id && (
                <TabContent
                  type={option?.type}
                  list={option?.data}
                  columnsConfig={option?.columnsConfig}
                  count={option?.count}
                />
              )}
            </TabPanel>
          ))}
        </TabPanels>
      </Box>
    </Tabs>
  );
};
